import AppProvidersProps from "./AppProviders.types";
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider
} from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import queryClient from "helpers/queryClient";
import auth from "helpers/auth";
import theme from "helpers/theme";
import { Provider as StoreProvider } from "react-redux";
import { persistor, store } from "context/store";
import { PersistGate } from "redux-persist/integration/react";
import { Suspense } from "react";
import Loading from "common/ui/Loading";
import { ErrorBoundary } from "react-error-boundary";
import Error from "common/ui/Error";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import dayjs from "dayjs";

dayjs.extend(duration);
dayjs.extend(isSameOrBefore);

function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorBoundary fallback={<Error />}>
      <Suspense fallback={<Loading />}>
        <StyledEngineProvider injectFirst>
          <CssBaseline>
            <BrowserRouter>
              <MsalProvider instance={auth.msalInstance}>
                <QueryClientProvider client={queryClient}>
                  <ThemeProvider theme={theme}>
                    <StoreProvider store={store}>
                      <PersistGate persistor={persistor}>
                        {children}
                        <ReactQueryDevtools initialIsOpen={false} />
                      </PersistGate>
                    </StoreProvider>
                  </ThemeProvider>
                </QueryClientProvider>
              </MsalProvider>
            </BrowserRouter>
          </CssBaseline>
        </StyledEngineProvider>
      </Suspense>
    </ErrorBoundary>
  );
}

export default AppProviders;
